/* The bell in the website header: a link to the person's notifications with the unread count on it. Where the inbox is and how to count comes
   from website_hq/inbox.py (an app registers it); this file holds no wording of its own. In the PWA shell pwahq draws its own bell, so this stands aside. */
(function () {
	"use strict";
	const BELL = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
	const call = async (method) => {
		try {
			const response = await fetch("/api/method/" + method, { method: "POST", credentials: "same-origin",
				headers: { "Content-Type": "application/json", Accept: "application/json", "X-Frappe-CSRF-Token": window.csrf_token || (window.frappe && frappe.csrf_token) || "" }, body: "{}" });
			return response.ok ? (await response.json()).message : null;
		} catch (e) { return null; }
	};
	const signedIn = () => /(?:^|;\s*)user_id=(?!Guest)/.test(document.cookie);

	async function init() {
		if (!signedIn() || document.querySelector(".rfhq-inbox-bell") || document.body.classList.contains("pwahq-active")) return;
		const nav = document.querySelector(".navbar .navbar-nav li.nav-item.dropdown.logged-in");
		if (!nav) return;
		const cfg = await call("raftor_websitehq.website_hq.inbox.config");
		if (!cfg || !cfg.url) return;
		const item = document.createElement("li");
		item.className = "nav-item rfhq-inbox-bell";
		const link = document.createElement("a");
		link.className = "nav-link"; link.href = cfg.url; link.innerHTML = BELL;
		const count = document.createElement("span");
		count.className = "rfhq-inbox-count"; count.hidden = true;
		link.append(count); item.append(link);
		nav.parentNode.insertBefore(item, nav);
		async function refresh() {
			const unread = Number(await call(cfg.unread)) || 0;
			count.hidden = unread < 1;
			count.textContent = unread > 99 ? "99+" : String(unread);
			link.setAttribute("aria-label", cfg.label + (unread ? ", " + unread : ""));
		}
		link.setAttribute("aria-label", cfg.label);
		refresh();
		setInterval(() => { if (!document.hidden) refresh(); }, 60000);
		document.addEventListener("visibilitychange", () => { if (!document.hidden) refresh(); });
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
